export const downloadJsonFile = (jsonContent: any, fileName: string) => {
    /*
    * Creates link and downloads JSON object.
    * Source: https://stackoverflow.com/questions/3749231/download-file-using-javascript-jquery
    * And: https://stackoverflow.com/questions/51215642/converting-object-into-json-and-downloading-as-a-json-file-in-react
    */
    const link = document.createElement("a");
    link.setAttribute('download', fileName);
    link.href = `data:text/json;charset=utf-8,${encodeURIComponent(
        JSON.stringify(jsonContent)
    )}`;
    document.body.appendChild(link);
    link.click();
    link.remove();
} 